import { SERVICE_LINKS } from "../../common/constants";
export interface IAuthorizationSetting {
    LoginUrl?: string;
    AuthorizationMode?: string;
}
export interface IStoredAuthorizationSetting {
    getAuthorizationSetting(): IAuthorizationSetting;
    setAuthorizationSetting(value: IAuthorizationSetting): void;
}

export class DefaultAuthorizationSetting implements IAuthorizationSetting {
    LoginUrl?: string;
    AuthorizationMode?: string;
    constructor() {
        this.LoginUrl = SERVICE_LINKS.IMMOVIETNAM_LOGIN_URL;
        this.AuthorizationMode = "OAuth2";
    }
}
export class LocalStoredAuthorizationSetting
    implements IStoredAuthorizationSetting {
    localStoredAuthorizationSettingKey = "AuthorizationSettingData";
    authorizationSettingData: IAuthorizationSetting;
    constructor() {
        this.refresh();
    }

    refresh() {
        let cacheValue = localStorage.getItem(
            this.localStoredAuthorizationSettingKey
        );
        this.authorizationSettingData = JSON.parse(
            cacheValue
        ) as IAuthorizationSetting;
    }
    getAuthorizationSetting(): IAuthorizationSetting {
        return this.authorizationSettingData || new DefaultAuthorizationSetting();
    }
    setAuthorizationSetting(value: IAuthorizationSetting): void {
        let json = JSON.stringify(value);
        localStorage.setItem(this.localStoredAuthorizationSettingKey, json);
    }
}